import {observable, action} from 'mobx';
import arrayMove from 'array-move';

import GroupProduct from './GroupProduct';

let key = 1;

export default class ProductGroup {
	@observable id = 0;
	@observable group_id = 0;
	/** @type {Array<GroupProduct>} */
	@observable products = [];

	/** @type {Group} */
	@observable group;

	_key;

	constructor(product_group) {
		if (product_group) {
			this.id = parseInt(product_group.id);
			this.group_id = parseInt(product_group.group_id);
			this.group = product_group.group;
			this.products = product_group.products.map(product => new GroupProduct({
				product_id: product.product.id,
				product_name: product.product.name,
				label: product.label,
				is_primary: product.is_primary
			}));
		}

		this._key = key++;
	}

	@action addGroupProductByItem(autocomplete_item) {
		const new_group_product = new GroupProduct({
			product_id: autocomplete_item.id,
			product_name: autocomplete_item.label,
			label: ''
		});

		if (this.products.find(gp => gp.product_id === new_group_product.id)) {
			console.warn('Такой товар уже выбран');

			return;
		}

		this.products.push(new_group_product);
	}

	/**
	 * @param {GroupProduct} group_product
	 * @param {boolean} is_primary
	 */
	@action setGroupProductPrimary(group_product, is_primary) {
		this.products.forEach(gp => gp.is_primary = false);

		group_product.is_primary = is_primary;
	}

	/**
	 * @param {GroupProduct} group_product
	 */
	@action removeGroupProduct(group_product) {
		this.products = this.products.filter(gp => gp._key !== group_product._key);

		if (this.products.length > 0 && !this.products.find(gp => gp.is_primary)) {
			this.products[0].is_primary = true;
		}
	}

	@action changeProductsOrder(old_index, new_index) {
		this.products = arrayMove(this.products, old_index, new_index);
	}
}
